import { NavLink, useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { useLang } from '../context/LangContext';
import { APP_VERSION } from '../App';

const NAV = [
  { to: '/',            icon: 'bi-grid-1x2',          key: 'nav_dashboard' },
  { to: '/connections', icon: 'bi-plug',              key: 'nav_connections' },
  { to: '/invoices',    icon: 'bi-receipt',           key: 'nav_invoices' },
  { to: '/analytics',   icon: 'bi-bar-chart-line',    key: 'nav_analytics' },
];
const ADMIN_NAV = [
  { to: '/users', icon: 'bi-people', key: 'nav_users' },
];

export default function Layout({ children }) {
  const { user, logout } = useAuth();
  const { t, lang, switchLang } = useLang();
  const navigate = useNavigate();

  function handleLogout() { logout(); navigate('/login'); }

  return (
    <div className="d-flex">
      <aside className="sidebar">
        <div className="sidebar-logo">
          <img
            src="/logo-fdconsult.png"
            alt="FDConsult"
            style={{ width: 130, display: 'block', background: '#fff', borderRadius: 6, padding: '5px 8px' }}
          />
          <span style={{ fontSize: 11, opacity: 0.6, marginTop: 4, display: 'block' }}>EngieTool</span>
        </div>

        <nav className="nav flex-column pt-2">
          {NAV.map(item => (
            <NavLink
              key={item.to}
              to={item.to}
              end={item.to === '/'}
              className={({ isActive }) => `nav-link${isActive ? ' active' : ''}`}
            >
              <i className={`bi ${item.icon}`} />
              {t(item.key)}
            </NavLink>
          ))}
          {user?.role === 'admin' && ADMIN_NAV.map(item => (
            <NavLink
              key={item.to}
              to={item.to}
              className={({ isActive }) => `nav-link${isActive ? ' active' : ''}`}
            >
              <i className={`bi ${item.icon}`} />
              {t(item.key)}
            </NavLink>
          ))}
        </nav>

        <div className="sidebar-footer">
          <div className="user-name">{user?.name}</div>
          <div style={{ fontSize: 11 }}>{user?.role}</div>
          <div className="lang-toggle">
            <button className={lang === 'nl' ? 'active' : ''} onClick={() => switchLang('nl')}>NL</button>
            <button className={lang === 'en' ? 'active' : ''} onClick={() => switchLang('en')}>EN</button>
          </div>
          <button
            onClick={handleLogout}
            className="btn btn-link p-0 mt-2"
            style={{ fontSize: 12, color: '#64748b' }}
          >
            <i className="bi bi-box-arrow-left me-1" />
            {t('nav_logout')}
          </button>
          <div style={{ fontSize: 10, color: '#475569', marginTop: 8 }}>v{APP_VERSION}</div>
        </div>
      </aside>

      <main className="main-content flex-grow-1">
        {children}
      </main>
    </div>
  );
}
